import React, { useState, useEffect } from "react";
import { fetchData } from "../axios_URL";
import "./ChatSupport.css";
import { Badge, containerClasses } from "@mui/material";

const ChatSupport = () => {
    const [companies, setCompanies] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [messages, setMessages] = useState([]);
    const [newMessage, setNewMessage] = useState("");
    const [unreadCounts, setUnreadCounts] = useState({});

    useEffect(() => {
        const getCompanies = async () => {
            try {
                const response = await fetchData("GET", "/api/admin/companies");
                setCompanies(response.data);
            } catch (error) {
                console.error("Error fetching companies:", error);
            }
        };
        getCompanies();
    }, []);

    useEffect(() => {
        const fetchUnreadMessages = async () => {
            try {
                const response = await fetchData("GET", "/api/admin/companies/messages/unread");
                console.log("response:", response.data);

                if (!Array.isArray(response.data)) {
                    console.error("Unexpected response format:", response.data);
                    return;
                }

                const unreadCountsMap = {};
                response.data.forEach(msg => {
                    if (msg.company_id) { // Ensure msg.company exists
                        unreadCountsMap[msg.company_id] = (unreadCountsMap[msg.company_id] || 0) + 1;
                    } else {
                        console.warn("Message is missing company data:", msg);
                    }
                });

                setUnreadCounts(unreadCountsMap);
            } catch (error) {
                console.error("Error fetching unread messages:", error);
            }
        };

        fetchUnreadMessages();
    }, []);


    const selectCompany = async (company) => {
        setSelectedCompany(company);
        try {
            // Mark messages as read
            const response = await fetchData("GET", `/api/admin/companies/messages/company/${company.id}`);
            setMessages(response.data);

            // Update unread count
            setUnreadCounts((prev) => ({ ...prev, [company.id]: 0 }));
            await fetchData("PUT", `/api/admin/companies/messages/mark-as-read/${company.id}`);
        } catch (error) {
            console.error("Error fetching messages:", error);
        }
    };


    const sendMessage = async () => {
        if (!newMessage.trim()) return;
        try {
            const response = await fetchData("POST", `/api/admin/companies/messages/write/${selectedCompany.id}`, { message: newMessage });
            setMessages([...messages, response.data]);
            setNewMessage("");
        } catch (error) {
            console.error("Error sending message:", error);
        }
    };

    return (
        <div className="chat-support">
            <div className="company-list">
                {companies.map((company) => (
                    <div key={company.id} className="company-item" onClick={() => selectCompany(company)}>
                        <span>{company.companyname}</span>
                        {unreadCounts[company.id] > 0 && <Badge badgeContent={unreadCounts[company.id]} color="error" />}
                    </div>
                ))}
            </div>
            <div className="chat-container">
                {selectedCompany ? (
                    <>
                        <div className="chat-header">Chat with {selectedCompany.companyname}</div>
                        <div className="chat-messages">
                            {messages.map((msg) => (
                                <div key={msg.id} className={`message ${msg.isemployeewrite ? "sent" : "received"}`}>
                                    {msg.message}
                                </div>
                            ))}
                        </div>
                        <div className="chat-input">
                            <input
                                type="text"
                                value={newMessage}
                                onChange={(e) => setNewMessage(e.target.value)}
                                placeholder="Type a message..."
                            />
                            <button onClick={sendMessage}>Send</button>
                        </div>
                    </>
                ) : (
                    <div className="chat-placeholder">Wählen Sie ein Unternehmen aus, um mit dem Chatten zu beginnen</div>
                )}
            </div>
        </div>
    );
};

export default ChatSupport;
